module.exports = __webpack_public_path__ + "img/icons8-instagram.b5b2fe19.svg";